import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = { style: {"color":"red"} }
const _hoisted_3 = {
  key: 0,
  class: "input-box"
}
const _hoisted_4 = {
  key: 1,
  class: "input-box"
}
const _hoisted_5 = {
  key: 2,
  class: "input-box"
}
const _hoisted_6 = {
  key: 3,
  class: "input-box"
}
const _hoisted_7 = {
  key: 4,
  class: "input-box"
}
const _hoisted_8 = {
  key: 5,
  class: "textarea-box"
}
const _hoisted_9 = {
  key: 6,
  class: "switch-box"
}
const _hoisted_10 = {
  key: 7,
  class: "select-box"
}
const _hoisted_11 = {
  key: 8,
  class: "upload-box"
}
const _hoisted_12 = {
  key: 9,
  class: "specs-box"
}
const _hoisted_13 = {
  key: 10,
  class: "editor-box"
}
const _hoisted_14 = {
  key: 11,
  class: "map-box"
}
const _hoisted_15 = {
  key: 12,
  class: "date-box",
  "dark-class": "dark"
}
const _hoisted_16 = {
  key: 13,
  class: "time-box",
  "dark-class": "dark"
}
const _hoisted_17 = {
  key: 14,
  class: "label-box"
}
const _hoisted_18 = {
  key: 15,
  class: "richtext-box"
}
const _hoisted_19 = {
  key: 16,
  class: "keyboard-box"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TimePicker = _resolveComponent("TimePicker")!

  return ($options.getConditionValue())
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["elem-form-item-box", 'item-' + $props.data.type]),
        ref: "elem"
      }, [
        _createElementVNode("p", _hoisted_1, [
          _createTextVNode(_toDisplayString($props.data.title) + _toDisplayString($options.getTypeName($props.data.type)) + " ", 1),
          _createElementVNode("span", _hoisted_2, _toDisplayString($props.data.required ? "*" : ""), 1)
        ]),
        ($props.data.type === 'Input')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(), _createBlock(_resolveDynamicComponent($options.getComponent('elem-input')), {
                title: $props.data.title,
                value: $options.getValue($props.data.field, $props.entity, $props.index),
                field: $props.data.field,
                type: "text",
                name: $data.name,
                placeholder: $props.data.placeholder,
                required: $props.data.required,
                onChange: $options.onChangeData
              }, null, 40, ["title", "value", "field", "name", "placeholder", "required", "onChange"]))
            ]))
          : ($props.data.type === 'Number')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(), _createBlock(_resolveDynamicComponent($options.getComponent('elem-input')), {
                  title: $props.data.title,
                  value: $options.getValue($props.data.field, $props.entity, $props.index),
                  field: $props.data.field,
                  type: "number",
                  name: $data.name,
                  placeholder: $props.data.placeholder,
                  required: $props.data.required,
                  onChange: $options.onChangeData
                }, null, 40, ["title", "value", "field", "name", "placeholder", "required", "onChange"]))
              ]))
            : ($props.data.type === 'Phone')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent($options.getComponent('elem-input')), {
                    title: $props.data.title,
                    value: $options.getValue($props.data.field, $props.entity, $props.index),
                    field: $props.data.field,
                    type: "number",
                    name: $data.name,
                    placeholder: $props.data.placeholder,
                    required: $props.data.required,
                    onChange: $options.onChangeData,
                    verify: "phone"
                  }, null, 40, ["title", "value", "field", "name", "placeholder", "required", "onChange"]))
                ]))
              : ($props.data.type === 'Price')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent($options.getComponent('elem-price')), {
                      title: $props.data.title,
                      value: $options.getValue($props.data.field, $props.entity, $props.index),
                      field: $props.data.field,
                      name: $data.name,
                      placeholder: $props.data.placeholder,
                      required: $props.data.required,
                      onChange: $options.onChangeData
                    }, null, 40, ["title", "value", "field", "name", "placeholder", "required", "onChange"]))
                  ]))
                : ($props.data.type === 'Password')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent($options.getComponent('elem-password')), {
                        title: $props.data.title,
                        value: $options.getValue($props.data.field, $props.entity, $props.index),
                        field: $props.data.field,
                        config: $props.data.passwordConfig,
                        name: $data.name,
                        disabled: !$props.data.edit && !!$options.getValue($props.data.field, $props.entity, $props.index),
                        placeholder: $props.data.placeholder,
                        required: $props.data.required,
                        onChange: $options.onChangeData
                      }, null, 40, ["title", "value", "field", "config", "name", "disabled", "placeholder", "required", "onChange"]))
                    ]))
                  : ($props.data.type === 'Textarea')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent($options.getComponent('elem-textarea')), {
                          name: $data.name,
                          title: $props.data.title,
                          placeholder: $props.data.placeholder,
                          required: $props.data.required,
                          onChange: $options.onChangeData,
                          value: $options.getValue($props.data.field, $props.entity, $props.index)
                        }, null, 40, ["name", "title", "placeholder", "required", "onChange", "value"]))
                      ]))
                    : ($props.data.type === 'Switch')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent($options.getComponent('elem-switch')), {
                            name: $data.name,
                            onChange: $options.onChangeData,
                            field: $props.data.field,
                            value: $options.getValue($props.data.field, $props.entity, $props.index),
                            shape: "square"
                          }, null, 40, ["name", "onChange", "field", "value"]))
                        ]))
                      : ($props.data.type === 'Select')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent($options.getComponent('elem-select')), {
                              name: $data.name,
                              onChange: $options.onChangeData,
                              datas: $props.data.selectConfig.data,
                              field: $props.data.field,
                              multiple: $props.data.selectConfig.multiple,
                              required: $props.data.required,
                              title: $props.data.title,
                              placeholder: $props.data.placeholder,
                              config: $props.data.selectConfig,
                              value: $options.getValue($props.data.field, $props.entity, $props.index, $props.data.selectConfig.controller ? 'uuid' : '')
                            }, null, 40, ["name", "onChange", "datas", "field", "multiple", "required", "title", "placeholder", "config", "value"]))
                          ]))
                        : ($props.data.type === 'Upload')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              (_openBlock(), _createBlock(_resolveDynamicComponent($options.getComponent('elem-upload')), {
                                name: $data.name,
                                value: $options.getValue($props.data.field, $props.entity, $props.index),
                                field: $props.data.field,
                                title: $props.data.title,
                                required: $props.data.required,
                                type: $props.data.uploadConfig.type,
                                accept: $props.data.uploadConfig.accept,
                                multi: $props.data.uploadConfig.multi,
                                onChange: $options.onChangeData
                              }, null, 40, ["name", "value", "field", "title", "required", "type", "accept", "multi", "onChange"]))
                            ]))
                          : ($props.data.type === 'Specs')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                (_openBlock(), _createBlock(_resolveDynamicComponent($options.getComponent('elem-specs')), {
                                  name: $data.name,
                                  value: $options.getValue($props.data.field, $props.entity, $props.index),
                                  onChange: $options.onChangeData
                                }, null, 40, ["name", "value", "onChange"]))
                              ]))
                            : ($props.data.type === 'Editor')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent($options.getComponent('elem-editor')), {
                                    name: $data.name,
                                    required: $props.data.required,
                                    title: $props.data.title,
                                    field: $props.data.field,
                                    placeholder: $props.data.placeholder,
                                    value: $options.getValue($props.data.field, $props.entity, $props.index)
                                  }, null, 8, ["name", "required", "title", "field", "placeholder", "value"]))
                                ]))
                              : ($props.data.type === 'Map')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    (_openBlock(), _createBlock(_resolveDynamicComponent($options.getComponent('elem-map')), {
                                      name: $data.name,
                                      required: $props.data.required,
                                      value: $options.getValue($props.data.field, $props.entity, $props.index)
                                    }, null, 8, ["name", "required", "value"]))
                                  ]))
                                : ($props.data.type === 'Date')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                      _createVNode(_component_DatePicker, {
                                        transfer: "",
                                        class: "date-picker",
                                        type: "datetime",
                                        name: $data.name,
                                        required: $props.data.required,
                                        field: $props.data.field,
                                        title: $props.data.title,
                                        placeholder: $props.data.placeholder || ('选择' + $props.data.title),
                                        "model-value": $options.getValue($props.data.field, $props.entity, $props.index)
                                      }, null, 8, ["name", "required", "field", "title", "placeholder", "model-value"])
                                    ]))
                                  : ($props.data.type === 'Time')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        _createVNode(_component_TimePicker, {
                                          class: "time-picker",
                                          type: "time",
                                          name: $data.name,
                                          required: $props.data.required,
                                          field: $props.data.field,
                                          title: $props.data.title,
                                          placeholder: $props.data.placeholder || ('选择' + $props.data.title),
                                          "model-value": $options.getValue($props.data.field, $props.entity, $props.index)
                                        }, null, 8, ["name", "required", "field", "title", "placeholder", "model-value"])
                                      ]))
                                    : ($props.data.type === 'Label')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                          (_openBlock(), _createBlock(_resolveDynamicComponent($options.getComponent('elem-label')), {
                                            name: $data.name,
                                            type: $props.data.labelConfig ? $props.data.labelConfig.type : 'input',
                                            required: $props.data.required,
                                            field: $props.data.field,
                                            title: $props.data.title,
                                            placeholder: $props.data.placeholder,
                                            value: $options.getValue($props.data.field, $props.entity, $props.index)
                                          }, null, 8, ["name", "type", "required", "field", "title", "placeholder", "value"]))
                                        ]))
                                      : ($props.data.type === 'RichText')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                            (_openBlock(), _createBlock(_resolveDynamicComponent($options.getComponent('elem-richtext')), {
                                              name: $data.name,
                                              required: $props.data.required,
                                              field: $props.data.field,
                                              value: $options.getValue($props.data.field, $props.entity, $props.index)
                                            }, null, 8, ["name", "required", "field", "value"]))
                                          ]))
                                        : ($props.data.type === 'Keyboard')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                              (_openBlock(), _createBlock(_resolveDynamicComponent($options.getComponent('elem-keyboard')), {
                                                name: $data.name,
                                                required: $props.data.required,
                                                field: $props.data.field,
                                                value: $options.getValue($props.data.field, $props.entity, $props.index)
                                              }, null, 8, ["name", "required", "field", "value"]))
                                            ]))
                                          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}